<div class="column-filter-container" (click)="$event.stopPropagation()">
  @if (sorting) {
    <div class="column-filter-header">
      <button (click)="sortChange('asc')">
        <mat-icon>{{ ascIcons[columnType] }}</mat-icon>
        {{ ascLabels[columnType] | translate }}
        @if (sortDirection === 'asc' || sortDirection === 'Ascending') {
          <mat-icon class="check-icon">done</mat-icon>
        }
      </button>
      <button (click)="sortChange('desc')">
        <mat-icon>{{ descIcons[columnType] }}</mat-icon>
        {{ descLabels[columnType] | translate }}
        @if (sortDirection === 'desc' || sortDirection === 'Descending') {
          <mat-icon class="check-icon">done</mat-icon>
        }
      </button>
    </div>
  }
  <div class="column-filter-content">
    @if (showSearch && (isTextColumn || isSectionedList)) {
      <app-ui-input
        label="{{ 'search' | translate }}"
        [placeholder]="'pleaseStartTypingToFilter' | translate"
        [control]="searchControl"
      ></app-ui-input>
    }
    @if (isDateColumn) {
      <app-shared-ui-datepicker
        [required]="false"
        [control]="dateFromControl"
        label="{{ 'from' | translate | titlecase }}"
      ></app-shared-ui-datepicker>
      <app-shared-ui-datepicker
        [required]="false"
        [control]="dateToControl"
        label="{{ 'to' | translate | titlecase }}"
      ></app-shared-ui-datepicker>
    }

    @if (isNumberColumn) {
      <div class="numeric-range">
        <app-ui-input
          label="{{ 'from' | translate | titlecase }}"
          [control]="fromControl"
          type="number"
        ></app-ui-input>
        <app-ui-input
          label="{{ 'to' | translate | titlecase }}"
          [control]="toControl"
          type="number"
        ></app-ui-input>
      </div>
    }
    @if (isBooleanColumn) {
      <app-shared-ui-radio
        [control]="booleanControl"
        [options]="booleanControlOptions"
      ></app-shared-ui-radio>
    }
    @if (isSectionedList) {
      <div class="sectioned-option-list">
        @for (section of optionSections; track section.property) {
          <div class="option-section">
            <div class="option-section-title">{{ section.labelKey | translate }}</div>
            @for (control of section.optionControls; track control.value) {
              <app-shared-ui-checkbox
                label="{{ control.label | translate }}"
                [control]="control.control"
              ></app-shared-ui-checkbox>
            }
          </div>
        }
      </div>
    } @else {
      <div class="option-list">
        @for (control of optionControlMap; track $index) {
          <app-shared-ui-checkbox
            label="{{ control.label | translate }}"
            [control]="control.control"
          ></app-shared-ui-checkbox>
        }
      </div>
    }
  </div>
  <div class="column-filter-checkboxes">
    @if (columnData.allowNullFilter) {
      <app-shared-ui-checkbox
        label="{{ 'noDate' | translate | titlecase }}"
        [control]="onlyNullControl"
      ></app-shared-ui-checkbox>
    }
  </div>
  <div class="column-filter-footer">
    <app-ui-button
      buttonType="secondary"
      [text]="'cancel' | translate"
      (click)="cancel()"
    ></app-ui-button>
    <app-ui-button
      buttonType="secondary"
      [text]="'clear' | translate"
      (click)="clear()"
    ></app-ui-button>
    <app-ui-button
      color="primary"
      [text]="'apply' | translate"
      [disabled]="columnData.allowNullFilter ? false : !controlsValid"
      (click)="apply()"
    ></app-ui-button>
  </div>
</div>
